import { z } from "zod/v4";

export const OrgShopIdDtoSchema = z.object({
  id: z.uuid(),
  shopId: z.string(),
});

export type OrgShopIdDto = z.infer<typeof OrgShopIdDtoSchema>;
